import { Card, Badge, Stack } from "react-bootstrap";
import Flag from "./Flag";
import { formatRut } from "../../validations/format";

const styles = {
  resultCard: {
    cursor: "pointer",
    transition: "all 0.2s",
  },
};

function SolicitanteCard({ solicitante, onVerFicha }) {
  const handleCardClick = () => {
    onVerFicha(solicitante.idS);
  };

  return (
    <Card className="p-3 solicitante-card" onClick={handleCardClick}>
      <div className="d-flex justify-content-between align-items-start">
        <div className="flex-grow-1">
          {/* NOMBRE + RUT + FLAG alineados */}
          <div className="d-flex align-items-baseline flex-wrap gap-2">
            <div onClick={(e) => e.stopPropagation()}>
              <Flag
                idSolicitante={solicitante.idS}
                initialFlag={solicitante.flag}
              />
            </div>

            <strong className="fs-5">{solicitante.nombre}</strong>

            <span className="text-muted">
              {solicitante.pasaporte
                ? solicitante.rut
                : formatRut(solicitante.rut)}
            </span>
          </div>

          {/* INFO ADICIONAL */}
          <div className="text-muted mt-1">
            <span className="me-3">
              <i className="bi bi-mortarboard me-1"></i>
              {solicitante.carrera || "Sin carrera"}
            </span>
            <span>
              <i className="bi bi-person-badge me-1"></i>
              {solicitante.tipo || "Sin tipo"}
            </span>
          </div>
        </div>
        <i className="bi bi-chevron-right text-muted ms-2"></i>
      </div>
    </Card>
  );
}

export default SolicitanteCard;